import emptySplitApi from "../utils/rtk";
import { CommonBody, PaymentModeType, } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
    status: number;
    message: string;
};
type GetPaymentModeResponse = {
    length: number;
    start: number;
    response_object: PaymentModeType[];
    total_records: number;
};

export const paymentModesApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllPaymentModes: builder.mutation<
            CommonResponseType & { data: GetPaymentModeResponse },
            CommonBody
        >({
            query: (body) => ({
                url: END_POINTS.getAllpaymentModes,
                method: "POST",
                body,
            }),
        }),

        deletePaymentMode: builder.query<
            CommonResponseType & { data: PaymentModeType },
            { id: number | null }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.deletePaymentMode}${id}/`,
                method: "DELETE",
            }),
        }),

        paymentModeDetail: builder.query<
            CommonResponseType & { data: PaymentModeType | null },
            { id: number }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.paymentModeById}${id}/`,
                method: "GET",
            }),
        }),
        updatePaymentMode: builder.mutation<
            CommonResponseType & { data: PaymentModeType },
            { body: CommonBody; id: number }
        >({
            query: ({ body, id }) => ({
                url: `${END_POINTS.updatePaymentMode}${id}/`,
                method: "PUT",
                body,
            }),
        }),
        addPaymentMode: builder.mutation<
            CommonResponseType & { data: PaymentModeType },
            CommonBody
        >({
            query: (body) => ({
                url: END_POINTS.addPaymentMode,
                method: "POST",
                body,
            }),
        }),
    }),
});

export const {
    useGetAllPaymentModesMutation,
    useAddPaymentModeMutation,
    useUpdatePaymentModeMutation,
    useLazyDeletePaymentModeQuery,
    useLazyPaymentModeDetailQuery,
} = paymentModesApi;
